import AppConfigStore from '../reverb-js-common/app_config_store';

const DEFAULT_ADYEN_LOCALE = 'en_US';
const REVERB_LANGUAGE_TO_ADYEN_LOCALE = {
  en: 'en_US', // english
  fr: 'fr_FR', // french
  ja: 'ja_JP', // japanese
  de: 'de_DE', // german
  it: 'it_IT', // italian
  nl: 'nl_NL', // dutch
  zh: 'zh_CN', // chinese - simplified
  da: 'da_DK', // danish
  no: 'no_NO', // norwegian
  pl: 'pl_PL', // polish
  pt: 'pt_BR', // portuguese
  es: 'es_ES', // spanish
  sv: 'sv_SE', // swedish
};

export interface MountComponentArgs {
  domSelector: string;
  type: string;
  locale: string;
  props: any;
}

function mapReverbLocaleToAdyenCheckoutLocale(reverbLocale: string): string {
  const language = reverbLocale.substring(0, 2);
  return REVERB_LANGUAGE_TO_ADYEN_LOCALE[language] || DEFAULT_ADYEN_LOCALE;
}

function buildAdyenCheckoutConfiguration(locale: string): AdyenCheckoutConfiguration {
  const { adyenCheckoutConfig } = AppConfigStore.getState();

  return {
    ...adyenCheckoutConfig,
    locale: mapReverbLocaleToAdyenCheckoutLocale(locale),
  };
}

export function mountComponent(args: MountComponentArgs) {
  const config = buildAdyenCheckoutConfiguration(args.locale);
  const checkout = new window.AdyenCheckout(config);
  const component = checkout.create(args.type, args.props);
  component.mount(args.domSelector);
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/adyen_checkout_mounter.ts